export default __webpack_public_path__ + "static/media/fedex.bb46c009.svg";